import { Navigate, useLocation, useNavigate } from 'react-router';
import { signInStaff } from '@ecobox/firebase';
import { LoginForm, StagingBanner } from '@ecobox/ui';
import { ECOBOX_ENV } from '../env';
import { useServices, useSession } from '../services';

export function LoginPage() {
  const { client } = useServices();
  const session = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';

  if (session.status === 'signed_in' && session.isStaff) return <Navigate to={from} replace />;

  return (
    <>
      <StagingBanner env={ECOBOX_ENV} />
      <main className="ops-login">
        <div className="ops-login__card">
          <LoginForm
            title="EcoBox Ops"
            subtitle="Sign in once. The app then works without signal."
            size="touch"
            onSubmit={async (username, password) => {
              await signInStaff(client.auth, username, password);
              void navigate(from, { replace: true });
            }}
          />
        </div>
      </main>
    </>
  );
}
